class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = this.debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    this.querySelector('form').addEventListener('input', this.debouncedOnSubmit);
    this.querySelectorAll('a').forEach((a) =>
      a.addEventListener('click', this.onActiveFilterClick)
    );
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const formData = new FormData(event.target.closest('form'));
    const searchParams = new URLSearchParams(formData).toString();
    this.renderPage(searchParams);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    this.renderPage(new URL(event.currentTarget.href).searchParams.toString());
  }

  renderPage(searchParams) {
    const url = `${window.location.pathname}?${searchParams}`;
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const productGrid = html.querySelector('#ProductGridContainer');
        const currentGrid = document.querySelector('#ProductGridContainer');

        if (productGrid && currentGrid) {
          currentGrid.innerHTML = productGrid.innerHTML;
          history.pushState({}, '', url);
        }
      });
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('facet-filters-form', FacetFiltersForm);